import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-custom-button',
  templateUrl: './custom-button.component.html',
  styleUrls: ['./custom-button.component.scss'],
  standalone: false
})
export class CustomButtonComponent {
  @Input() text = 'Click me';
  @Input() color = 'primary';
  @Input() disabled = false;
}
